import React from 'react';
import { Breadcrumb } from 'src/app/slice';
import { getBreadcrumbLabel } from './breadcrumbsHelper';
import { StyledLink, StyledTextButton } from './style';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { useLinkUpdater } from 'src/commons/utils/linkUpdater';

export const LinkBreadcrumb: React.FC<{ breadcrumb: Breadcrumb }> = ({
  breadcrumb,
}) => {
  const transformUrl = useLinkUpdater();

  if (breadcrumb.onClickCallback) {
    return (
      <StyledTextButton
        onClick={breadcrumb.onClickCallback}
        {...getTaktAttributes(`button-breadcrumb`, chromeComponents.HEADER, {
          label: breadcrumb.label,
        })}
      >
        {getBreadcrumbLabel(breadcrumb)}
        {!!breadcrumb.objectSuffix && (
          <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
        )}
      </StyledTextButton>
    );
  }

  const resolvedUrl =
    breadcrumb.url && transformUrl
      ? transformUrl(breadcrumb.url)
      : breadcrumb.url;

  return (
    <StyledLink
      href={resolvedUrl}
      {...getTaktAttributes(
        `link-breadcrumb`,
        chromeComponents.HEADER,
        resolvedUrl ? { url: resolvedUrl, label: breadcrumb.label } : {},
      )}
    >
      {getBreadcrumbLabel(breadcrumb)}
      {!!breadcrumb.objectSuffix && (
        <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
      )}
    </StyledLink>
  );
};
